import React, { useContext, useEffect, useState } from 'react';
import Util from '../../Util';
import Breadcrumb from '../shared/Breadcrumb';
import SideNav from './shared/SideNav';
import axios from 'axios';
import { apiRoutes } from '../../AppSettings';
import { AuthContext } from '../../contexts/AuthContext';
import alertify from 'alertifyjs';

const Settings = () => {
    const { userState } = useContext(AuthContext);
  
    const initialValue = {
        websiteName: '',
        logo: '',
        favicon: '',
        voiceCallFee: 0,
        videoCallFee: 0
    };
    const [setting, setSetting] = useState(initialValue);

    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
    };

    useEffect(() => {
        axios.get(apiRoutes.LoadSetting, options)
        .then((response) => {
            console.log(response)

            if(response.status === 200)
            {
				const data = response.data;
                setSetting(data);
		    }
        }, (error) => {
          console.log(error.response);
        });
    }, []);

    const handleSubmit = () => {
        axios.post(apiRoutes.UpsertSetting, JSON.stringify(setting), options)
        .then((response) => {
            if(response.status === 200)
            {
				alertify.success("setting added/updated successfully");
            }
        }, (error) => {
            console.log(error);
        });
    }

    const getFilesLogo = (e) => {
        var reader = new FileReader();
        reader.onload = function(upload) {
            setSetting({...setting, logo: upload.target.result})
        };
	    reader.readAsDataURL(e.target.files[0]);
    }

    const getFilesFavicon = (e) => {
        var reader = new FileReader();
        reader.onload = function(upload) {
            setSetting({...setting, favicon: upload.target.result})
        };
	    reader.readAsDataURL(e.target.files[0]);
    }
    return (  
        <div>
            <Breadcrumb title="Specialities"></Breadcrumb>
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <SideNav applyCssFor='settings' />
                        </div>
                        <div className="col-md-7 col-lg-8 col-xl-9">
                            <div className="row">
                                <div className="col-md-12">
                                    <form onSubmit={e => {e.preventDefault(); handleSubmit();}} >
                                        <div className="card">
                                            <div className="card-body">
                                                    <div className="form-group">
                                                        <label>Website Name</label>
                                                        <input type="text" className="form-control" required value={setting.websiteName} onChange={e => setSetting({...setting, websiteName: e.target.value })}  />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Website Logo</label>
                                                        <div className="change-avatar">
                                                            <div className="profile-img">
                                                                <img src={Util.loadImage(setting.logo)} alt="User Image" />
                                                            </div>
                                                            <div className="upload-img">
                                                                <input type="file" className="form-control" 
                                                                    onChange={e => getFilesLogo(e)}
                                                                    required
                                                                    accept="image/*" /> 
                                                                <small className="form-text text-muted">Recommended image size is <b>150px x 150px</b></small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group mb-0">
                                                        <label>Favicon</label>
                                                        <div className="change-avatar">
                                                            <div className="profile-img">
                                                                <img src={Util.loadImage(setting.favicon)} alt="User Image" />
                                                            </div>
                                                            <div className="upload-img">
                                                                <input type="file" className="form-control" 
                                                                        onChange={e => getFilesFavicon(e)}
                                                                        required
                                                                        accept="image/*" />
                                                                 <small className="text-secondary">Recommended image size is <b>16px x 16px</b> or <b>32px x 32px</b></small><br />
                                                                <small className="text-secondary">Accepted formats : only png and ico</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group" style={{marginTop: '50px'}}>
                                                        <label>Voice Call Fee</label>
                                                        <input type="number" className="form-control" required value={setting.voiceCallFee} onChange={e => setSetting({...setting, voiceCallFee: e.target.value })}  />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Video Call Fee</label>
                                                        <input type="number" className="form-control" required value={setting.videoCallFee} onChange={e => setSetting({...setting, videoCallFee: e.target.value })}  />
                                                    </div>
                                            </div>
                                        </div>
                                        <div className="submit-section submit-btn-bottom">
                                            <button type="submit" className="btn btn-primary submit-btn">Save Changes</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Settings;